module.exports = __webpack_public_path__ + "img/logo.d94a5de4.svg";